import { createFileRoute } from '@tanstack/react-router';
import { OrderingSettingsPage } from '@/features/table-ordering/pages/ordering-settings-page';

export const Route = createFileRoute('/_app/settings/online-ordering')({ component: OrderingSettingsPage });
